var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRelationRight = function SvgRelationRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 50,
    viewBox: "0 0 24 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 36C11 37.6569 12.3431 39 14 39H21C21.5523 39 22 38.5523 22 38V38C22 37.4477 21.5523 37 21 37H14C13.4477 37 13 36.5523 13 36V14C13 13.4477 13.4477 13 14 13H21C21.5523 13 22 12.5523 22 12V12C22 11.4477 21.5523 11 21 11H14C12.3431 11 11 12.3431 11 14V36Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2.69819,
    transform: "matrix(1 0 0 -1 21.3018 12)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4095 36.5858L19.874 33.0503C19.4834 32.6597 18.8503 32.6597 18.4598 33.0503V33.0503C18.0692 33.4408 18.0692 34.0739 18.4597 34.4645L20.5811 36.5858C21.3621 37.3668 21.3621 38.6332 20.5811 39.4142L18.4598 41.5355C18.0692 41.9261 18.0692 42.5592 18.4598 42.9497V42.9497C18.8503 43.3403 19.4834 43.3403 19.874 42.9497L23.4095 39.4142V39.4142C24.1905 38.6332 24.1905 37.3668 23.4095 36.5858V36.5858Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRelationRight);
export { ForwardRef as ReactComponent };